import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class SeoService {

    constructor(
        private meta: Meta
    ) { }

    setMetaTags(title: string, description: string, route: string) {
        this.meta.updateTag({ name: 'title', title })
        this.meta.updateTag({ name: 'description', description })

        this.meta.updateTag({ property: 'og:title', content: title })
        this.meta.updateTag({ property: 'og:description', content: description })
        this.meta.updateTag({ property: 'og:type', content: 'website' })
        this.meta.updateTag({ property: 'og:url', content: `https://tennis.one/${route}` })
        this.meta.updateTag({ property: 'og:image:alt', content: 'TennisONE Branded Logo' })
    }
}
